import script from "./GoalBreadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalBreadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./GoalBreadcrumb.vue?vue&type=style&index=0&id=2ddddf5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ddddf5f"]])

export default __exports__